import React from "react";
import { Button, Modal } from "@mui/material";
import styles from "./DeleteModal.module.scss";

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  name: string;
  supportingText: string;
  onDelete: () => void;
};

const DeleteModal = ({
  isOpen,
  setIsOpen,
  name,
  supportingText,
  onDelete,
}: Props) => {
  return (
    <Modal
      aria-labelledby="modal-delete"
      aria-describedby="Removal from the system. Confirm the deletion"
      open={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <div className={styles.modalContainer}>
        <h3 className={styles.modalTitle}>
          Delete <span className={styles.modalTitleRed}>{name}?</span>
        </h3>
        <p className={styles.modalSupportText}>{supportingText}</p>
        <div className={styles.modalContent}>
          <div className={styles.btns}>
            <Button
              sx={{
                textTransform: "capitalize",
                height: "44px",
                width: "130px",
                backgroundColor: "#FF0000",
                border: "none",
                borderRadius: "12px",
                "&:hover": {
                  backgroundColor: "#FF0000",
                },
              }}
              variant="contained"
              onClick={onDelete}
            >
              Delete
            </Button>

            <Button
              variant="outlined"
              sx={{
                textTransform: "capitalize",
                height: "44px",
                width: "130px",
                border: "1px solid #5570F1",
                color: "#5570F1",
                borderRadius: "12px",
              }}
              onClick={() => setIsOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
